import React from "react";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, msg: "" };
  }
  static getDerivedStateFromError(error) {
    return { hasError: true, msg: (error && (error.message || String(error))) || "Unknown error" };
  }
  componentDidCatch(error, info) {
    console.error("App crashed:", error, info);
  }
  render() {
    if (this.state.hasError) {
      return (
        <div style={{ minHeight: "100vh", display: "flex", flexDirection: "column",
          alignItems: "center", justifyContent: "center", background: "#0A192F",
          color: "#fff", fontFamily: "Manrope, sans-serif", padding: "24px", textAlign: "center" }}>
          <h1 style={{ fontFamily: "Oswald, sans-serif", fontSize: "2rem", textTransform: "uppercase", letterSpacing: "-0.02em" }}>AUM</h1>
          <p style={{ opacity: 0.8, marginTop: 12 }}>Something went wrong while loading the page.</p>
          <code style={{ display: "block", marginTop: 10, maxWidth: 600, fontSize: 12,
            color: "#ff9d9d", wordBreak: "break-word" }} data-testid="error-message">{this.state.msg}</code>
          <button onClick={() => window.location.reload()}
            style={{ marginTop: 20, background: "#1A4D8F", color: "#fff", border: "none",
              padding: "12px 28px", textTransform: "uppercase", letterSpacing: "0.15em",
              fontSize: 12, fontWeight: 700, cursor: "pointer" }}>
            Reload
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
